import { render, staticRenderFns } from "./OEAttachments.vue?vue&type=template&id=b7bf3116&scoped=true&"
import script from "./OEAttachments.vue?vue&type=script&lang=js&"
export * from "./OEAttachments.vue?vue&type=script&lang=js&"
import style0 from "./OEAttachments.vue?vue&type=style&index=0&id=b7bf3116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf3116",
  null
  
)

export default component.exports